export const rfidStringToArray = (rfids: string | null) =>
  (rfids || "")
    .split(/\,|\;/)
    .map((rfid) => rfid.trim())
    .filter((rfid) => !!rfid)
